import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OperationResult } from '@tb/auth';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { Mode } from 'src/app/model/subscription';
import { ModelService } from 'src/app/core/services/model.service';
import { IndustriesPurchasedDetails } from 'src/app/model/IndustriesPurchasedDetails';
import { IndustryPurchasedInfo } from 'src/app/model/industry';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
    selector: 'ms-multicompany-creation-button',
    templateUrl: './multicompany-creation-button.component.html',
    styleUrls: ['./multicompany-creation-button.component.scss'],
})
export class MulticompanyCreationButtonComponent implements OnInit {
    public industryPurchased: IndustryPurchasedInfo;
    @Input() cur_subscriptionKey: string;
    @Input() cur_subscriptionDescri: string;
    @Input() disabled: boolean;
    // @Input() cur_subMode: string;
    @Input() cur_signature: string;
    cur_subModeTemp: string;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);

    constructor(
        private router: Router,
        public storeRolesService: StoreRolesService,
        private modelService: ModelService,
        private loginService: LoginService
    ) {}

    async ngOnInit() {
        authorizationProperties: AuthorizationProperties;

        if (this.cur_subscriptionKey) {
            let resultDetails: OperationResult = await this.modelService.getIndustryPurchasedDetails(
                this.authorizationProperties.accountName,
                this.cur_subscriptionKey
            );

            if (resultDetails.Result) {
                let industryPurchasedDetails: IndustriesPurchasedDetails = resultDetails.Content as IndustriesPurchasedDetails;
                this.industryPurchased = JSON.parse(industryPurchasedDetails.IndustryPurchased) as IndustryPurchasedInfo;
                //this.editionDescription = this.industryPurchased.Edition.EditionDescription;
                this.cur_subModeTemp = Mode[this.industryPurchased.SubscriptionMode];
            }
        }
    }

    redirectToSlaveManagement() {
        if (this.cur_subscriptionKey) {
            this.router.navigate(['/store/SlaveManagement'], {
                queryParams: {
                    subKey: btoa(this.cur_subscriptionKey),
                    subMode: Mode.rtm.toString(),
                    productID: this.cur_signature,
                },
            });
        }
    }

    setDisabled() {
        return this.disabled;
        //if (!this.cur_signature || this.cur_signature.length == 0 ) return false;

        // if (!this.storeRolesService.IsInternal) {
        //     if (this.cur_signature == ProductCode.MAGOCLD && this.cur_subModeTemp != Mode.rtm.toString()) {
        //         return true;
        //    } else {
        //         return false;
        //     }
        // }
        // if (this.storeRolesService.IsInternal) {
        //     if (this.cur_signature == ProductCode.MAGOWEB) return false;
        //      else return true;
        // } else return true;
    }
}
